import { VERSION_COMPARISON_DEFAULT_PAGE } from './constants'
import { TSelectedVersion } from './types'

/**
 * Compute total pages from selected versions
 * Returns the MAXIMUM total pages among all versions
 */
export const computeTotalPages = (versions?: TSelectedVersion[] | null) => {
  if (!versions || versions.length === 0) return VERSION_COMPARISON_DEFAULT_PAGE

  const totals = versions
    .map((v) => v.totalPages)
    .filter(
      (page): page is number =>
        typeof page === 'number' && page >= VERSION_COMPARISON_DEFAULT_PAGE
    )

  if (!totals.length) return VERSION_COMPARISON_DEFAULT_PAGE

  return Math.max(...totals)
}
